/**
 * Creates a Promise that waits `n` ms.
 * @param ms
 * @returns
 */
export function wait(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
